import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=2534a5df&"
import script from "./TheSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2534a5df')) {
      api.createRecord('2534a5df', component.options)
    } else {
      api.reload('2534a5df', component.options)
    }
    module.hot.accept("./TheSidebar.vue?vue&type=template&id=2534a5df&", function () {
      api.rerender('2534a5df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TheSidebar.vue"
export default component.exports